import React from 'react'
import { CustomCard } from '@softura/fluentuipackage'
import './Card.scss'

interface IProps {
  content?: any,
  children?: any,
  className?: string,
  title?: string | number,
  DocumentCardActivityPeople?: any,
  shouldTruncate?: any,
  'data-attribute'?: any,
}
const CardContainer = ({
  children = null,
  className,
  title = '',
  DocumentCardActivityPeople = '',
  shouldTruncate = '',
  'data-attribute': dataAttribute
}:IProps) => {
  return (
    <span data-attribute={dataAttribute}>
    <CustomCard
    content={children}
    className = {className}
    title = {title}
    DocumentCardActivityPeople = {DocumentCardActivityPeople}
    shouldTruncate = {shouldTruncate}
    
    />
    </span>
  )
}

export default CardContainer
